module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/produto-segmento/produto-segmento.component.css
// module id = ./src/app/produto-segmento/produto-segmento.component.css
// module chunks = main